/**
 * @generated SignedSource<<8414e592df18d03d3e5dd4f739f9adff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type useTranslatableField_data$data = {
  readonly languages: ReadonlyArray<{
    readonly locale: Locale;
  }>;
  readonly " $fragmentType": "useTranslatableField_data";
};
export type useTranslatableField_data$key = {
  readonly " $data"?: useTranslatableField_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"useTranslatableField_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useTranslatableField_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Language",
      "kind": "LinkedField",
      "name": "languages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "locale",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "d4331a1208968ef2805fd11a441809ab";

export default node;
